<button
  class="nav-link text-center announcement-badge"
  type="button"
  (click)="toggle()"
  [attr.aria-label]="'ANNOUNCEMENTS.OPEN' | translate"
  >
  <i class="lnr lnr-alarm" aria-hidden="true"></i>
  @if ((unreadCount$ | async); as count) {
    <span
      class="announcement-badge__count"
      aria-hidden="true"
      >{{ count }}</span
      >
    }
  </button>
